import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, useAuth, useT } from '@repo/common';

const FinalDeleteSuccess = ({ $isMobile }) => {
  const t = useT();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  return (
    <div className='flex flex-col tabletH:items-center justify-center w-[460px]'>
      <div className='flex flex-col tabletH:items-center pb-6 tabletH:pb-10 gap-0.5 tabletH:gap-1 text-text-primary'>
        <div className='typo-b16Strong tabletH:typo-title2'>
          {t('Account deleted', '계정이 삭제되었습니다')}
        </div>
        <div className='typo-title1 tabletH:typo-h5'>
          {t(
            'Thanks for being with Koready.',
            '그동안 Koready와 함께해 주셔서 감사합니다.',
          )}
        </div>
      </div>
      <BaseButton
        type='secondary'
        size={$isMobile ? 'l' : 'xl'}
        hideIcon
        width='100%'
        onClick={() => {
          navigate('/');
          refreshUser();
        }}
      >
        {t('Back to Home', '홈으로 돌아가기')}
      </BaseButton>
    </div>
  );
};

export default FinalDeleteSuccess;
